<!-- //ALEXMODI -->
<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap class="chartBox">
      
      <v-flex md5 v-show="!printMode">
        <v-select
            clearable
            @input='updateProtocol'
            @clear='updateProtocol'
            :v-model="protocolId"
            :items="this.$store.getters.protocols"
            placeholder='Choose Protocol'
            item-text="name"
            item-value="id"
          />
      </v-flex>

      <v-flex md5 v-show="!printMode">
        <v-select
            clearable
            @input='updateCountry'
            :v-model="countryId"
            :items="countries"
            placeholder='Choose country'
          />
      </v-flex>

      <v-flex md2 v-show="!printMode">
        <v-btn
          :disabled="!protocolId"
          color="pink"
          dark
          small
          @click="print()">
          Print
          <v-icon>mdi-print</v-icon>
        </v-btn>
      </v-flex>

      <v-flex md12>
        <material-card
            color="primary"
            title="Sae Status Update"
            text=""
            class="elevation-1"
          >

          <!--chartist
            :data="data"
            :options="options"
            ratio="ct-major-tenth"
            type="Bar"
          /-->

           <charts-bar
            :chart-data="chartData"
            :options="chartOptions"
            ref="chart"
          />


        </material-card>
      </v-flex>

      <v-flex md12>
        <material-card
            color="primary"
            :title="'Sae Status Update by ' + itemLabel"
            text=""
            class="elevation-1"
          >

           <v-layout justify-center wrap>
                <v-flex xs12 md3 v-for="(item, index) in items" v-bind:key="index" >
                  <v-card>
                    <v-card-title :style="'background:'+item.bgcolor"><b>{{ item.title }}</b></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>

                      <v-list-tile>
                        <v-list-tile-content>{{itemLabel}}</v-list-tile-content>
                        <v-list-tile-content class="align-end">Grand Total</v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile v-for="(value, key, index) in item.data" v-bind:key="index">
                        <v-list-tile-content>{{key}}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ value }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
           </v-layout>
          
        </material-card>
      </v-flex>


       <v-flex md6>
        <!-- issue vari -->
        <material-card
            color="primary"
            title="Compliance Metrics - Initial SAEs"
            text=""
            class="elevation-1"
          >
        <!-- issue vari -->

          <v-tooltip top v-if="!printMode">
            <template slot="activator" slot-scope="{ on }">
              <v-btn
                v-on="on"
                :disabled="!protocolId"
                color="pink"
                style="margin-right:8px"
                dark
                small
                absolute
                top
                right
                @click="downloadExcel('awareness')">
                Export Excel
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span> Export Excel - Diff with Date of Awareness</span>
          </v-tooltip>

          <v-layout justify-center wrap>
                <v-flex xs12 md10 v-for="(item, index) in items_awareness" v-bind:key="index">
                  <v-card>
                    <!-- issue vari -->
                    <v-card-title style="background:#FDFF72"><b>{{ item.title }} - Initial SAEs</b></v-card-title>
                    <!-- issue vari -->
                    <v-divider></v-divider>
                    <v-list dense>

                      <v-list-tile>
                        <v-list-tile-content style="width:250px">{{itemLabel}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">NO</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">YES</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">Grand Total</v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile v-for="(i, k, index) in item.data" v-bind:key="index">
                        <v-list-tile-content style="width:250px">{{k}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.no}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.yes}}</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">{{i.tot}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
           </v-layout>
        </material-card>
       </v-flex>


       <v-flex md6>
        <material-card
            color="primary"
            title="Compliance Metrics - Company"
            text=""
            class="elevation-1"
          >

          <v-tooltip top v-if="!printMode">
            <template slot="activator" slot-scope="{ on }">
              <v-btn
                v-on="on"
                :disabled="!protocolId"
                color="pink"
                style="margin-right:8px"
                dark
                small
                absolute
                top
                right
                @click="downloadExcel('notification')">
                Export Excel
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span> Export Excel - Diff with company notification Date</span>
          </v-tooltip>

          <v-layout justify-center wrap>
                <v-flex xs12 md10 v-for="(item, index) in items_notification" v-bind:key="index">

                  <v-card>
                    <v-card-title style="background:#FDFF72"><b>{{ item.title }} - Company</b></v-card-title>
                    <v-divider></v-divider>

                    <v-list dense>
                      <v-list-tile>
                        <v-list-tile-content style="width:250px">{{itemLabel}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">NO</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">YES</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">Grand Total</v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile v-for="(i, k, index) in item.data" v-bind:key="index">
                        <v-list-tile-content style="width:250px">{{k}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.no}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.yes}}</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">{{ i.tot }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
           </v-layout>
        </material-card>
       </v-flex>


        <v-flex md6>
        <material-card
            color="primary"
            title="Compliance Metrics - Eudravigilance 7 days"
            text=""
            class="elevation-1"
          >

          <v-tooltip top v-if="!printMode">
            <template slot="activator" slot-scope="{ on }">
              <v-btn
                v-on="on"
                :disabled="!protocolId"
                color="pink"
                style="margin-right:8px"
                dark
                small
                absolute
                top
                right
                @click="downloadExcel('reporting7')">
                Export Excel
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span> Export Excel - Diff with reporting Date - 7 days</span>
          </v-tooltip>

          <v-layout justify-center wrap>
                <v-flex xs12 md10 v-for="(item, index) in items_reporting7" v-bind:key="index">
                  <v-card>
                    <v-card-title style="background:#FDFF72"><b>{{ item.title }} - Eudravigilance 7 days</b></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      
                      <v-list-tile>
                        <v-list-tile-content style="width:250px">{{itemLabel}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">NO</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">YES</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">Grand Total</v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile v-for="(i, k, index) in item.data" v-bind:key="index">
                        <v-list-tile-content style="width:250px">{{k}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.no}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.yes}}</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">{{i.tot}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
           </v-layout>
        </material-card>
       </v-flex>


        <v-flex md6>
        <material-card
            color="primary"
            title="Compliance Metrics - Eudravigilance 15 days"
            text=""
            class="elevation-1"
          >
          <v-tooltip top v-if="!printMode">
            <template slot="activator" slot-scope="{ on }">
              <v-btn
                v-on="on"
                :disabled="!protocolId"
                color="pink"
                style="margin-right:8px"
                dark
                small
                absolute
                top
                right
                @click="downloadExcel('reporting15')">
                Export Excel
                <v-icon>mdi-file-excel</v-icon>
              </v-btn>
            </template>
            <span> Export Excel - Diff with reporting Date - 15 days</span>
          </v-tooltip>

          <v-layout justify-center wrap>
                <v-flex xs12 md10 v-for="(item, index) in items_reporting15" v-bind:key="index">
                  <v-card>
                    <v-card-title style="background:#FDFF72"><b>{{ item.title }} - Eudravigilance 15 days</b></v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      
                      <v-list-tile>
                        <v-list-tile-content style="width:250px">{{itemLabel}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">NO</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">YES</v-list-tile-content>
                        <v-list-tile-content class="align-end">Grand Total</v-list-tile-content>
                      </v-list-tile>

                      <v-list-tile v-for="(i, k, index) in item.data" v-bind:key="index">
                        <v-list-tile-content style="width:250px">{{k}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.no}}</v-list-tile-content>
                        <v-list-tile-content class="align-center" style="width:50px">{{i.yes}}</v-list-tile-content>
                        <v-list-tile-content class="align-end" style="width:50px">{{ i.tot }}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
           </v-layout>
        </material-card>
       </v-flex>

        <v-flex md12 v-if="printMode">
          <h3>{{protocolName}} | {{now}}</h3>
        </v-flex>

      

    </v-layout>


  </v-container>
</template>


<script>
import Vue from 'vue'
import { getList, remove, get, downloadExcel } from "@/api/base_api"
import 'chartist-plugin-legend'
import 'chartist-plugin-pointlabels'
import jsPDF from 'jspdf' 
import VueHtml2Canvas from 'vue-html2canvas'

//import pdfMake from "pdfmake/build/pdfmake";
//import pdfFonts from "pdfmake/build/vfs_fonts";
//pdfMake.vfs = pdfFonts.pdfMake.vfs;

Vue.use(VueHtml2Canvas)

export default {
  data() {
    return {
      protocolId: null,
      countryId: null,
      items: [],
      countries: [],
      items_awareness: [],
      items_notification: [],
      items_reporting7: [],
      items_reporting15: [],
      printMode: false,
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        showAllTooltips: false,

        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
              //max: 100,
              // stepSize: 10,
            }
          }]
        },

       animation: {
        duration: 1,
        onComplete: function () {
            var chartInstance = this.chart,
                ctx = chartInstance.ctx;
            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            this.data.datasets.forEach(function (dataset, i) {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach(function (bar, index) {
                    var data = dataset.data[index];                            
                    ctx.fillText(data, bar._model.x + 15, bar._model.y + 5);
                });
            });
        }
       }
      }
    };
  },
  computed: {
    itemLabel() {
      return this.countryId ? 'Site' : 'Country'
    },
    protocolName() {
      const prots = this.$store.getters.protocols.filter( el => el.id == this.protocolId )
      if(prots.length) {
        return prots[0].name
      }
      return ''
    },
    now() {
      const d = new Date()
      return d.toLocaleString('en-us',{day: 'numeric', month:'long', year:'numeric'}) + ' ' + d.toLocaleTimeString();
    }
  },
  created() {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    getData() {

      get('/metrics/countries/' + this.protocolId).then( data => {
        this.countries = data
      })

      var url = this.countryId ? '/metrics/generalStatus/' + this.protocolId + '/' + this.countryId : '/metrics/generalStatus/' + this.protocolId
      get(url).then( data => {

        var keys = Object.keys(data);
        var values = keys.map(function(v) { return data[v]; });

          this.chartData.labels = keys
          this.chartData.datasets = []
          this.chartData.datasets.push({
            label: 'SAE/AESI',
            backgroundColor: '#f87979',
            data: values
          }) 
          
          let max = Math.max(...values)
          max = max + (max/100*10)
          this.chartOptions.scales.xAxes[0].ticks.suggestedMax = max

          this.$refs.chart.refresh_data()

      })

      var url = this.countryId ? '/metrics/generalStatusCountries/' + this.protocolId + '/' + this.countryId : '/metrics/generalStatusCountries/' + this.protocolId
      get(url).then( data => {
        this.items = data
      })

      var url = this.countryId ? '/metrics/dateAwarenessCountries/' + this.protocolId + '/' + this.countryId : '/metrics/dateAwarenessCountries/' + this.protocolId
      get(url).then( data => {
        this.items_awareness = data
      })

      var url = this.countryId ? '/metrics/dateNotificationCountries/' + this.protocolId + '/' + this.countryId : '/metrics/dateNotificationCountries/' + this.protocolId
      get(url).then( data => {
        this.items_notification = data
      })
      
      var url = this.countryId ? '/metrics/dateReporting7Countries/' + this.protocolId + '/' + this.countryId : '/metrics/dateReporting7Countries/' + this.protocolId
      get(url).then( data => {
        this.items_reporting7 = data
      })

      var url = this.countryId ? '/metrics/dateReporting15Countries/' + this.protocolId + '/' + this.countryId : '/metrics/dateReporting15Countries/' + this.protocolId
      get(url).then( data => {
        this.items_reporting15 = data
      })
    },
    updateProtocol(v) {

      this.countries = []
      this.items = []
      this.items_awareness = []
      this.items_notification = []
      this.items_reporting7 = []
      this.items_reporting15 = []
      this.chartData.labels = []
      this.chartData.datasets = []
      this.$refs.chart.refresh_data()

      this.protocolId = v
      if(v) {
        this.getData()
      }
    },
    updateCountry(v) {
      this.countryId = v
      this.getData()
    },
    downloadExcel(type) {
      var url = this.countryId ? '/metrics/excel/datediff/'+type+'/'+this.protocolId + '/' + this.countryId : '/metrics/excel/datediff/'+type+'/'+this.protocolId
      downloadExcel(url)
    },
    async print() {
      
      this.$store.dispatch("app/startLoading");

      this.printMode = true
      await new Promise(r => setTimeout(r, 200));

      const charts = document.querySelectorAll(".chartBox");

      let that = this;

      async function createImages() {

         var newCanvas = document.createElement('canvas'),
            ctx = newCanvas.getContext('2d'), 
            width = 0, 
            height = 0;

        let y = 0
        let results = [];
        for (let item of charts) {
            var imgData = await that.$html2canvas(item);
            height = height + imgData.height
            if(imgData.width > width) {
              width = imgData.width
            }
            results.push(imgData);
        }

        newCanvas.width = width;
        newCanvas.height = height;

        results.forEach(function(n) {
            ctx.beginPath();
            ctx.drawImage(n, 0, y, n.width, n.height);
            y = y + n.height
        });

        return [newCanvas.toDataURL(), width, height];
      }

       createImages().then((data) => {
          const imgData = data[0]
          const width = data[1]
          const height = data[2]
          const pdf = new jsPDF('p', 'px', [width, height]);
          var img = new Image();
          img.src = imgData;
          pdf.addImage(img, 'png', 0, 0, width, height);
          var now = new Date().toISOString();
          pdf.save('Safety_Metrics_export_'  + now + '.PDF');
          this.$store.dispatch("app/stopLoading");
          this.printMode = false
       })


    }

  },
  
};
</script>

<style lang="scss">
#company_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
}


</style>
